import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-company-registration',
    templateUrl: './question-company-registration.component.html',
    styleUrls: ['./question-company-registration.component.scss'],
    standalone: false
})
export class QuestionCompanyRegistrationComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-registration-number-${newGuid()}`;
  uniqueId = `textbox-registration-number-id-${newGuid()}`;
  value = '';

  constructor() { }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
    
  }

  saveValue(): void {
    if (this.value && this.question) {
      this.question.answer = this.value.toString();
      this.questionAnswer.emit(this.question);
    }
  }
}
